"use strict";

import Cookies from "js-cookie";

// 事件行为判定cookie
export function getToken(name) {
  return Cookies.get(name);
}

export function setToken(name, value, data) {
  if (data) {
    return Cookies.set(name, value, { expires: data });
  } else {
    return Cookies.set(name, value);
  }
}

export function removeToken() {
  return Cookies.remove(eventKey);
}

// Storage存储
const sessionStorage = window.sessionStorage;
const localStorage = window.localStorage;

// sessionStorage存储封装
export function setSessionStorage(key, val) {
  sessionStorage.setItem(key, val);
}

export function getSessionStorage(key) {
  return sessionStorage.getItem(key);
}
export function removesessionStorage(key) {
  return sessionStorage.removeItem(key);
}

// localStorage存储封装
export function setLocalStorage(key, val) {
  localStorage.setItem(key, val);
}
export function getLocalStorage(key) {
  return localStorage.getItem(key);
}
export function removeLocalStorage(key) {
  return localStorage.removeItem(key);
}
